import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=27de0c91&"
import script from "./Research.vue?vue&type=script&lang=js&"
export * from "./Research.vue?vue&type=script&lang=js&"
import style0 from "./Research.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports